import { defaultSysCodeDto, SysCodeDto } from "src/dtos/code/sysCodeDto";


export interface SYS1010_R01UpdateDto {
	majorCodeDto: SYS1010_R01Dto;
	minorCodeDtoList: SYS1010_R01Dto[];
}


export interface SYS1010_R01Dto extends SysCodeDto {
	listLength?: number;
	refetchListLength?: number;
}

export const defaultSYS1010_R01Dto: SYS1010_R01Dto = {
	...defaultSysCodeDto,
	listLength: 0,
	refetchListLength: 0,
	minorCd: `$`,
};

export const defaultDetailSYS1010_R01: SYS1010_R01Dto = {
	...defaultSYS1010_R01Dto,
	minorCd: ``,
};
